import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { SdkEvents } from 'constants/enums';
import { selectSdkCallbackStorage } from 'selectors/selectors';
import { useWindowSizeDebounced } from 'src/hooks/useIsMobile';

export const useToggleChatWindowSizeOnMobile = () => {
  const { isMobile } = useWindowSizeDebounced();
  const sdkCallbackStorage = useSelector(selectSdkCallbackStorage);
  const hasToggled = useRef(false);

  useEffect(() => {
    if (!isMobile || hasToggled.current) return;

    const toggleChatWindowSize = sdkCallbackStorage.get(SdkEvents.TOGGLE_CHAT_WINDOW_SIZE);

    if (!toggleChatWindowSize) return;

    toggleChatWindowSize({ name: SdkEvents.TOGGLE_CHAT_WINDOW_SIZE });
    hasToggled.current = true;
  }, [isMobile, sdkCallbackStorage]);
};
